import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { NormalizedArgument } from '@/@types'
import { getAcceptabilityFromProCon, pluralize } from '@/store'
import ScoreIcon from './ScoreIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Acceptability',
  props: {
    items: {},
    alternative: {},
    icon: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const acceptability = computed(() => getAcceptabilityFromProCon(props.items))

const scoreTitle = computed(() => {
  return acceptability.value !== null
    ? `${pluralize('{count} {argument:count}', {
        count: props.items.length
      })} - ${acceptability.value * 100}% pro`
    : ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScoreIcon, {
    title: scoreTitle.value,
    alternative: _ctx.alternative,
    icon: _ctx.icon,
    score: acceptability.value
  }, null, 8, ["title", "alternative", "icon", "score"]))
}
}

})